const config = {
  auth_pages: {
    signin: "https://clientzone.fxmundo.net/login",
    signup: "https://clientzone.fxmundo.net/signup",
  },
};

export default config;